import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";
import toast from "react-hot-toast";
import Influencers from "./Influencers";
import { getCampaignById, getInfluencersByCampaignId } from "../../api/campaigns";
import { TextInput } from "flowbite-react";
import { HiSearch } from "react-icons/hi";

const CampaignDetail = () => {
  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lookalikes, setLookalikes] = useState([]);
  const [search, setSearch] = useState('');

  const fetchCampaign = useCallback(async () => {
    try {
      const response = await getCampaignById(id);
      setCampaign(response);
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error.message || 'Failed to fetch campaign details.');
    }
  }, [id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchInfluencers = useCallback(
    debounce(async (searchTerm) => {
      try {
        const response = await getInfluencersByCampaignId({
          id,
          data: {
            page,
            s: searchTerm,
          },
        });

        setLookalikes(response.influencers || []);
        setTotalPages(response.totalPages || 1);
      } catch (error) {
        console.error(error);
        toast.error(error?.response?.data?.message || error.message || 'Failed to fetch influencers.');
      }
    }, 500),
    [id, page]
  );

  useEffect(() => {
    if (id) {
      fetchCampaign();
    }
  }, [id, fetchCampaign]);

  useEffect(() => {
    fetchInfluencers(search);
  }, [search, fetchInfluencers]);

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">{campaign?.name}</h1>
        <TextInput
          icon={HiSearch}
          placeholder="Search"
          name="s"
          id="s"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <Influencers
        lookalikes={lookalikes}
        page={page}
        totalPages={totalPages}
        onPageChange={(value) => setPage(value)}
      />
    </>
  );
};

export default CampaignDetail;
